import { Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';
import useToggle from '#/hooks/use-toggle';
import ParadigmModal from '#/material/modal';
import EditMmpSettingsForm from '#/pages/settings/components/edit-mmp-settings-form';
import { updateMmpSettingsApi } from '#/api/desk-api';

const EditMmpSettings = ({ children, settings, onSettingsUpdate }) => {
  const [open, toggle] = useToggle(false);

  const mmpSchema = Yup.object().shape({
    mmp_reset_interval_seconds: Yup.number()
      .min(1, 'Must be at least 1 second')
      .nullable(true)
      .notRequired(),
    execution_window: Yup.number()
      .min(1, 'Must be at least 1 second')
      .nullable(true)
      .notRequired(),
    execution_limit: Yup.number()
      .min(1, 'Must be at least 1')
      .integer('Must be an integer')
      .nullable(true)
      .notRequired(),
    volume_threshold: Yup.number()
      .min(0, 'Must be positive')
      .nullable(true)
      .notRequired(),
    volume_window: Yup.number()
      .min(1, 'Must be at least 1 second')
      .nullable(true)
      .notRequired(),
  });

  const initialValues = {
    mmp_reset_interval_seconds: settings.mmp_reset_interval_seconds || '',
    execution_window: settings.execution_window || '',
    execution_limit: settings.execution_limit || '',
    volume_threshold: settings.volume_threshold || '',
    volume_window: settings.volume_window || '',
  };

  const handleSubmit = async (values) => {
    const parseNumeric = (value, parser = Number) =>
      value === '' || value === null || value === undefined
        ? null
        : parser(value);

    // Ensure values are numbers or null before sending
    const settingsToUpdate = {
      mmp_reset_interval_seconds: parseNumeric(
        values.mmp_reset_interval_seconds,
        parseInt,
      ),
      execution_limit: parseNumeric(values.execution_limit, parseInt),
      execution_window: parseNumeric(values.execution_window, parseInt),
      volume_threshold: parseNumeric(values.volume_threshold, parseFloat),
      volume_window: parseNumeric(values.volume_window, parseInt),
    };

    try {
      await updateMmpSettingsApi(settingsToUpdate);
      toggle(); // Close modal on success
      onSettingsUpdate(); // Trigger refresh in parent component
    } catch (error) {
      console.error('Failed to update MMP settings:', error);
      throw error; // Let Formik handle the error
    }
  };

  return (
    <>
      {React.cloneElement(children, {
        onClick: toggle,
      })}
      {open && (
        <ParadigmModal
          title="Market Maker Protection Settings"
          onClose={toggle}
        >
          <Formik
            onSubmit={handleSubmit}
            validationSchema={mmpSchema}
            initialValues={initialValues}
          >
            {(props) => <EditMmpSettingsForm {...props} onClose={toggle} />}
          </Formik>
        </ParadigmModal>
      )}
    </>
  );
};

export default EditMmpSettings;
